import dynamic from 'next/dynamic'

const AccountLayout = {
  Team: dynamic(() => import('./TeamsLayout')),
  User: dynamic(() => import('./UserLayout')),
}

export default AccountLayout
